<template>
	<vs-input
		v-bind="$attrs"
		v-on="$listeners"
		:value="value"
		:maxlength="maxLength"
		@input="val => $emit('input', val)"
	/>
</template>

<script>
export default {
	name: "CbsInput",
	inheritAttrs: false,
	props: {
		value: {
			required: true
		},
		dataType: {
			type: String,
			validator: prop => ["int", "float", "text"].includes(prop),
			default: "text"
		}
	},
	computed: {
		maxLength() {
			const inputMaxLengthConfig = {
				int: 12,
				float: 15,
				text: 255
			};

			return inputMaxLengthConfig[this.dataType] || null;
		}
	}
};
</script>
